
(() => {
  const $ = (s, ctx=document) => ctx.querySelector(s);
  const $$ = (s, ctx=document) => [...ctx.querySelectorAll(s)];
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: window.WinkWire?.currency || 'USD'}).format(cents/100); }
    catch(e){ return '$' + (cents/100).toFixed(2); }
  };
  const toast = (msg) => {
    const el = $('#wwToast'); if(!el) return;
    el.textContent = msg; el.classList.add('show');
    clearTimeout(window.__wwToast); window.__wwToast=setTimeout(()=>el.classList.remove('show'),1800);
  };
  const setBodyLock = locked => document.body.classList.toggle('cart-open', locked);

  // Mobile menu
  const menuToggle=$('#menuToggle'), mobileMenu=$('#mobileMenu');
  menuToggle?.addEventListener('click', ()=>{
    const open=mobileMenu.classList.toggle('open');
    menuToggle.setAttribute('aria-expanded', open ? 'true':'false');
    mobileMenu.setAttribute('aria-hidden', open ? 'false':'true');
  });

  // Search overlay
  const searchPanel=$('#searchPanel');
  $$('[data-search-open]').forEach(b=>b.addEventListener('click', ()=>{
    searchPanel?.classList.add('open'); setBodyLock(true); setTimeout(()=>$('#wwSearchInput')?.focus(),100);
  }));
  $$('[data-search-close]').forEach(b=>b.addEventListener('click', ()=>{searchPanel?.classList.remove('open');setBodyLock(false);}));
  document.addEventListener('keydown', e=>{ if(e.key==='Escape'){searchPanel?.classList.remove('open'); closeCart(); setBodyLock(false);} });

  // Cart drawer
  const drawer=$('#cartDrawer');
  function openCart(){ if(!drawer) return; drawer.classList.add('open'); setBodyLock(true); refreshCart(); }
  function closeCart(){ drawer?.classList.remove('open'); setBodyLock(false); }
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click', closeCart));

  async function getCart(){ const r=await fetch('/cart.js',{headers:{Accept:'application/json'}}); if(!r.ok) throw new Error('Cart unavailable'); return r.json(); }
  function updateCartCount(cart){ $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count); }
  function renderCart(cart){
    updateCartCount(cart);
    const body=$('#cartDrawerItems'), total=$('#cartDrawerTotal'); if(!body||!total) return;
    if(!cart.items.length){ body.innerHTML='<div class="empty-cart">Your cart is empty.</div>'; total.textContent=money(0); return; }
    body.innerHTML=cart.items.map((item,i)=>`<div class="cart-line" data-line="${i+1}">
      ${item.image ? `<img src="${item.image}" alt="">`:'<div class="cart-img-placeholder"></div>'}
      <div><a href="${item.url}"><h4>${item.product_title}</h4></a><small>${item.variant_title && item.variant_title!=='Default Title' ? item.variant_title : ''}</small>
        <div class="qty-controls"><button type="button" data-cart-qty="${i+1}" data-qty="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-qty="${i+1}" data-qty="${item.quantity+1}">+</button></div>
      </div>
      <div class="cart-line-price"><strong>${money(item.final_line_price)}</strong><button class="line-remove" type="button" data-cart-qty="${i+1}" data-qty="0" aria-label="Remove ${item.product_title}">×</button></div>
    </div>`).join('');
    total.textContent=money(cart.total_price);
    $$('[data-cart-qty]',body).forEach(btn=>btn.addEventListener('click', async()=>{
      btn.disabled=true; try{ await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(btn.dataset.cartQty),quantity:Number(btn.dataset.qty)})}); await refreshCart(); } finally{btn.disabled=false;}
    }));
  }
  async function refreshCart(){ try{renderCart(await getCart());}catch(e){} }

  // Native quick add via Shopify Ajax Cart API
  $$('.quick-add-form').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault(); const btn=$('button',form); btn.disabled=true;
    try{
      const fd=new FormData(form); const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
      if(!r.ok) throw new Error('Could not add item');
      await refreshCart(); toast('Added to cart'); openCart();
    }catch(err){ toast(err.message || 'Could not add item'); }
    finally{btn.disabled=false;}
  }));

  // Product variant selector updates displayed price and featured image.
  $$('[data-product-form]').forEach(wrap=>{
    const select=$('select[name="id"]',wrap), price=$('[data-product-price]',wrap), compare=$('[data-product-compare]',wrap), image=$('[data-product-image]',document);
    if(!select) return;
    select.addEventListener('change',()=>{
      const opt=select.options[select.selectedIndex];
      if(price && opt.dataset.price) price.textContent=money(Number(opt.dataset.price));
      if(compare){ const c=Number(opt.dataset.compare||0); compare.textContent=c ? money(c):''; compare.style.display=c?'':'none'; }
      if(image && opt.dataset.image) image.src=opt.dataset.image;
    });
  });

  // Reveal effects
  const observer=('IntersectionObserver' in window) ? new IntersectionObserver(entries=>entries.forEach(x=>x.isIntersecting&&x.target.classList.add('visible')),{threshold:.08}) : null;
  $$('.reveal').forEach(el=>observer?observer.observe(el):el.classList.add('visible'));
  refreshCart();
})();
